// extracted by mini-css-extract-plugin
export default {"loader":"yy-njkV8Q-squLvIEdT79A==","loading":"_0PQEIfXz1A-nuz-Djoqa7A=="};